"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "scrollIntoView", {
    enumerable: true,
    get: function() {
        return scrollIntoView;
    }
});
const scrollIntoView = (target, scrollParent)=>{
    if (!target || !scrollParent) {
        return;
    }
    if (scrollParent.offsetHeight >= scrollParent.scrollHeight) {
        return;
    }
    const { offsetHeight, offsetTop } = target;
    const { offsetHeight: parentOffsetHeight, scrollTop } = scrollParent;
    const isAbove = offsetTop < scrollTop;
    const isBelow = offsetTop + offsetHeight > scrollTop + parentOffsetHeight;
    const buffer = 2;
    if (isAbove) {
        scrollParent.scrollTo(0, offsetTop - buffer);
    }
    if (isBelow) {
        scrollParent.scrollTo(0, offsetTop - parentOffsetHeight + offsetHeight + buffer);
    }
};
